import MasEnvironment from '../types/MasEnvironment';

export default {
  environment: process.env.MAS_ENV as MasEnvironment,
  issuerUrl: process.env.OPENID_ISSUER_URL as string,
  clientId: process.env.OPENID_CLIENT_ID as string,
  redirectUri: window.origin,
};
